import { Logger } from '@elyx-code/common-ts-utils';
import { ConnectionNodeType, IConnectionDrawingOptions } from '..';
import {
	EntryPointEntityState,
	DraggablePassThroughCallableEntityState,
	ProjectState,
	ChangeSet,
	EntityWithLogicScopeState,
	CallerEntityState,
	ArgumentDeclarationState,
	OutputMapState,
	ValueDescriptorState,
	VariableState,
	ExecutableEntityState,
	InputMapState,
	EntityWithNames,
} from '@elyx-code/project-logic-tree';
import { getScopeOwner } from '@elyx-code/project-logic-tree';

export function connectPassthroughCallable(
	newPassThroughCallable: DraggablePassThroughCallableEntityState,
	connectionOptions: IConnectionDrawingOptions,
	project: ProjectState,
	changeSet: ChangeSet
) {
	if (connectionOptions?.nodeType === ConnectionNodeType.EntryPointCaller) {
		newPassThroughCallable.addEntryCaller(
			connectionOptions.source as EntryPointEntityState,
			changeSet,
			true
		);
		(connectionOptions.source as EntryPointEntityState).addCall(
			newPassThroughCallable,
			changeSet
		);

		newPassThroughCallable.setParent(
			connectionOptions.source as EntryPointEntityState,
			changeSet
		);
	} else if (connectionOptions?.nodeType === ConnectionNodeType.SuccessCaller) {
		Logger.log(
			'Adding success call from node-type: ',
			ConnectionNodeType.SuccessCaller
		);
		newPassThroughCallable.addSuccessCaller(
			connectionOptions.source as DraggablePassThroughCallableEntityState,
			changeSet,
			true
		);
		(
			connectionOptions.source as DraggablePassThroughCallableEntityState
		).addSuccessCall(newPassThroughCallable, changeSet, true);

		const callerOwner = getScopeOwner(connectionOptions.source, project);

		if (callerOwner) {
			newPassThroughCallable.setParent(callerOwner, changeSet);
		}
	} else if (connectionOptions?.nodeType === ConnectionNodeType.ErrorCaller) {
		
		newPassThroughCallable.addErrorCaller(
			connectionOptions.source as DraggablePassThroughCallableEntityState,
			changeSet,
			true
		);
		(
			connectionOptions.source as DraggablePassThroughCallableEntityState
		).addErrorCall(newPassThroughCallable, changeSet, true);

		const callerOwner = getScopeOwner(connectionOptions.source, project);

		if (callerOwner) {
			newPassThroughCallable.setParent(callerOwner, changeSet);
		}
	} else if (connectionOptions?.nodeType === ConnectionNodeType.CalledBy) {
		Logger.log(
			'Adding success call from node-type: ',
			ConnectionNodeType.CalledBy
		);
		newPassThroughCallable.addSuccessCall(
			connectionOptions.target as DraggablePassThroughCallableEntityState,
			changeSet,
			true
		);
		(
			connectionOptions.target as DraggablePassThroughCallableEntityState
		).addSuccessCaller(newPassThroughCallable, changeSet, true);
	}
}

export function resolveNewParentFromConnectionsScopeOwner(
	project: ProjectState,
	connectedSource?:
		| CallerEntityState
		| ArgumentDeclarationState
		| OutputMapState
		| ValueDescriptorState
		| VariableState,
	connectedTarget?:
		| ExecutableEntityState
		| InputMapState
		| VariableState
): EntityWithLogicScopeState | ProjectState | null {
	if (!!connectedSource) {
		return getScopeOwner(connectedSource, project);
	} else if (!!connectedTarget) {
		return getScopeOwner(connectedTarget, project);
	} else {
		return project;
	}
}

export function findNextAvailableName(baseName: string, allEntitiesOfType: EntityWithNames[]): string {
	let newName = baseName;

	const nameAlreadyTaken = !!allEntitiesOfType.some(
		(ent) => ent.name === newName
	);

	if (nameAlreadyTaken) {
		const parts = baseName.split(' ');
		const suffix = parts.pop();
		const suffixAsNumber = parseInt(suffix);
		const hasSuffixNumber = !isNaN(suffixAsNumber);

		if (hasSuffixNumber) {
			parts.push(`${suffixAsNumber + 1}`);
		} else {
			parts.push(suffix);
			parts.push('1');
		}

		newName = parts.join(' ');

		return findNextAvailableName(newName, allEntitiesOfType);
	}

	return newName;
}